import { render, staticRenderFns } from "./ContractDetails.html?vue&type=template&id=1264d326&scoped=true&external"
import script from "./ContractDetails.js?vue&type=script&lang=js&external"
export * from "./ContractDetails.js?vue&type=script&lang=js&external"
import style0 from "./ContractDetails.scss?vue&type=style&index=0&id=1264d326&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1264d326",
  null
  
)

export default component.exports